import { render, staticRenderFns } from "./MeuCadastro.vue?vue&type=template&id=99c5f60a"
import script from "./MeuCadastro.vue?vue&type=script&lang=ts"
export * from "./MeuCadastro.vue?vue&type=script&lang=ts"
import style0 from "./MeuCadastro.vue?vue&type=style&index=0&id=99c5f60a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports